export default __webpack_public_path__ + "static/media/briefcase.ff493df1.svg";